
import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListPayService extends Vue {
    @Prop({default: {}})
    private listReceipt: any;
    private isCheckAll = false;
    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckAll: 'eventCheckAll'
    };

    private async viewDetail(receipt: any) {
        const routeData = this.$router.resolve({ name: 'receipt-detail', params: { id: receipt.id.toString() } });
        window.open(routeData.href, '_blank');
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '';
        }
        return formatNumber(value, format);
    }

    private async onCheckAllOrder() {
        this.$emit(this.eventEmit.eventCheckAll, this.isCheckAll);
    }
}
